import { analytics_methods } from "../../utils/analytics_methods";
import addKeysToSchema from "./schema";
import getItemstData from "../../utils/items_checkout";

function triggerEvent() {

    const schema = addKeysToSchema({
        time_selected: "string",
        date_selected: "string",
        ticket_category: "string",
    });
    
    const data = {
        event: window?.analytics_buendia?.event_name ?? null,
        event_type: "ecommerce",
        ecommerce: {
            value: window?.analytics_buendia?.total_value_with_commission ?? null,
            currency: window?.analytics_buendia?.currency || null,
            items: getItemstData()
        }
    }
    
    
    analytics_methods.sendToDataLayer(data, schema);
}


export const checkout_event = {
    triggerEvent
}